import React from "react";
import { Link } from "react-router-dom";

const FormButtonPanel = ({
  isFetching,
  onDelete,
  onTestConnection,
  onExecuteTask,
  formType,
  parentUrl,
  allowDelete,
  allowSave,
  isAdmin,
  isActive,
  endpointName,
  values
}) => {
  let isDeleteAllowed = true;
  let finalAllowDelete = allowDelete !== undefined ? allowDelete : true;
  let finalAllowSave = allowSave !== undefined ? allowSave : true;
  let finalisAdmin = isAdmin !== undefined ? isAdmin : true;
 
  return (
    <div className="form-button-panel">
      <div className="btn-group">
        {endpointName != "messagequeues" && endpointName != "jobqueues" && endpointName != "preferences" &&(
          <button
            type="submit"
            className="btn btn-success ml-1 mr-0"
            title="save"
            disabled={isFetching}
          >
            {isFetching ? (
              <i className="fa fa-circle-notch fa-spin fa-fw"></i>
            ) : (
                <i className="fa fa-save fa-fw"></i>
              )}{" "}
            Save{" "}
          </button>
        )}
        {endpointName == 'preferences' &&(
          <button
            type="submit"
            className="btn btn-success ml-1 mr-0"
            title="save"
            disabled={isFetching}
          >
            {isFetching ? (
              <i className="fa fa-circle-notch fa-spin fa-fw"></i>
            ) : (
                <i className="fa fa-save fa-fw"></i>
              )}{" "}
            Save{" "}
          </button>
        )}
        {/** Comment out this dropdown menu for now, revisit later
                  *
                    <div className="dropdown">
                    <button className="btn caret" id="save-dropdown" data-toggle="dropdown" disabled={isFetching} type="button" data-placement="top"><i className="fas fa-caret-down"></i></button>
                        
                        <ul className="dropdown-menu" role="menu" aria-labelledby="menu1" id="save-dropdown-list">
                            <li className="nav-item" role="presentation"><a className="nav-link" role="menuitem" tabIndex="-1" href="# ">Save and go back to {endpointName} list</a></li>
                            <li className="nav-item" role="presentation"><a className="nav-link" role="menuitem" tabIndex="-1" href="# ">Save and add new entry</a></li>
                            <li className="nav-item" role="presentation"><a className="nav-link" role="menuitem" tabIndex="-1" href="# ">Add new entry</a></li>
                        </ul>
                        
                    </div> 
                */}
      </div>

      <Link to={parentUrl}>
        <button
          type="button"
          className={"btn btn-warning ml-1 " + (isFetching ? "disabled" : "")}
          data-toggle="tooltip"
          data-placement="top"
          title="cancel"
        >
          <i className="fas fa-ban"></i> Cancel
        </button>
      </Link>

      {formType === "edit" && finalAllowDelete && endpointName != "schedules" ? (
        <button
          type="button"
          onClick={onDelete}
          className="btn btn-danger ml-1"
          data-toggle="tooltip"
          data-placement="top"
          title="delete"
          disabled={isFetching}
        >
          <i className="fas fa-trash"></i> Delete
        </button>
      ) : null}

      {
        /*formType === "edit" && finalAllowDelete && endpointName == "connections" && finalisAdmin ? (*/
        formType === "edit" && endpointName == "connections" ? (
        <button
          type="button"
          onClick={onTestConnection}
          className="btn btn-testing ml-1"
          data-toggle="tooltip"
          data-placement="top"
          title="test connection"
          disabled={isFetching}
        >
          <i className="fas fa-link"></i> Test Connection
        </button>
      ) : null}

      {formType === "edit"  && endpointName == "Integrations" && (
        <button
          type="button"
          onClick={onExecuteTask}
          className="btn btn-execute ml-1"
          data-toggle="tooltip"
          data-placement="top"
          title="execute task"
          disabled={isActive}
        >
          <i className="fas fa-bolt"></i> Execute Task
        </button>
      ) 
      }

      {/* {formType === "edit" && finalAllowDelete && endpointName == "Integrations" ? (
        <div className="btn-group align-items-center justify-content-center float-right" role="group" aria-label="object functions">
          <Link to={`/integrations/${values}/mapping`} className="btn">
              Field Mapping <i className="fas fa-angle-double-right"></i>
          </Link>
        </div>
      ) : null} */}
    </div>
  );
};

export default FormButtonPanel;



// WEBPACK FOOTER //
// ./src/components/utilities/FormButtonPanel.js